import { Box } from "@mui/material";
import React from "react";
import CustomTextField from "../../../../../components/common/Textfield";
import { StepComponentProps } from "../../AddBookingV2";
import StepHeader from "../StepHeader";
import VenueSearchField from "../VenueSearchField";

const OtherServiceStep: React.FC<StepComponentProps> = ({
  bookingData,
  setBookingData,
  isEdit,
  onUpdate,
  submitting,
}) => {
  const handleChange = (field: string, value: unknown) =>
    setBookingData((prev) => ({ ...prev, [field]: value as string }));

  return (
    <Box
      sx={{ width: "100%", display: "flex", flexDirection: "column", gap: 3 }}
    >
      <StepHeader
        title="Service Details"
        isEdit={isEdit}
        onUpdate={onUpdate}
        submitting={submitting}
      />

      <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 3 }}>
        <CustomTextField
          label="Type of Content"
          value={bookingData.content_type || ""}
          onChange={(e) => handleChange("content_type", e.target.value)}
        />
        <CustomTextField
          label="Title"
          value={bookingData.title || ""}
          onChange={(e) => handleChange("title", e.target.value)}
        />
        <CustomTextField
          label="Subtitle"
          value={bookingData.sub_title || ""}
          onChange={(e) => handleChange("sub_title", e.target.value)}
        />
      </Box>

      <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 3 }}>
        <CustomTextField
          label="Host Name"
          value={bookingData.hosts || ""}
          onChange={(e) => handleChange("hosts", e.target.value)}
        />
        <CustomTextField
          label="Guest Name"
          value={bookingData.guests || ""}
          onChange={(e) => handleChange("guests", e.target.value)}
        />
        <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2 }}>
          <CustomTextField
            label="Start Time"
            type="time"
            InputLabelProps={{ shrink: true }}
            value={bookingData.start_time || ""}
            onChange={(e) => handleChange("start_time", e.target.value)}
          />
          <CustomTextField
            label="End Time"
            type="time"
            InputLabelProps={{ shrink: true }}
            value={bookingData.end_time || ""}
            onChange={(e) => handleChange("end_time", e.target.value)}
          />
        </Box>
      </Box>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr 1fr",
          gap: 3,
          alignItems: "start",
        }}
      >
        <CustomTextField
          label="Date"
          type="date"
          InputLabelProps={{ shrink: true }}
          value={bookingData.start_date_of_event || ""}
          onChange={(e) => handleChange("start_date_of_event", e.target.value)}
        />
        <VenueSearchField
          bookingData={bookingData}
          setBookingData={setBookingData}
        />
        <CustomTextField
          label="Address One"
          value={bookingData.address_one || ""}
          onChange={(e) => handleChange("address_one", e.target.value)}
          disabled={bookingData.areAddressFieldsDisabled}
        />
      </Box>

      <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 3 }}>
        <CustomTextField
          label="Address Two"
          value={bookingData.address_two || ""}
          onChange={(e) => handleChange("address_two", e.target.value)}
          disabled={bookingData.areAddressFieldsDisabled}
        />
        <CustomTextField
          label="Suburb"
          value={bookingData.suburb || ""}
          onChange={(e) => handleChange("suburb", e.target.value)}
          disabled={bookingData.areAddressFieldsDisabled}
        />
        <CustomTextField
          label="City"
          value={bookingData.city || ""}
          onChange={(e) => handleChange("city", e.target.value)}
          disabled={bookingData.areAddressFieldsDisabled}
        />
      </Box>
    </Box>
  );
};

export default OtherServiceStep;
